module.exports = "/_next/static/images/instrument_6-91210f8fd2656d30cf7f83bdc44ebcc7.png";